export const LOCALIZED_ICON_TYPE = {
  CHEVRON_FORWARD: 'CHEVRON_FORWARD',
  ARROW_BACK: 'ARROW_BACK',
} as const;

export type LocalizedIconType =
  (typeof LOCALIZED_ICON_TYPE)[keyof typeof LOCALIZED_ICON_TYPE];
